// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1Tz-h","image":"styles_image__1Wvyf","title":"styles_title__2QR9v","largeTitle":"styles_largeTitle__3sn7H","text":"styles_text__3iliB"};